// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"4daeff9c","239":"60adb3f1","488":"ed8e4d68","732":"0fdcbe85"}[chunkId] + ".chunk.js";
};